<div style="padding:24px 32px 0">
    <app-tenant-base-info
        [item]="data"
    ></app-tenant-base-info>
</div>
